
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ContractFilter} from '../../contract/models/contract-filter';
import {BaseRestService} from './base-rest.service';
import {AppSettingsService} from './app-settings.service';
import {ArrayResponse, SendBackResult, serializeQueryString} from '..';
import {SubscriptionsList} from '../models/subscription';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class SubscriptionsListService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'SubscriptionsListService'; }

  protected get isAnonymous(): boolean { return false; }

  getList(uuid: string, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    return this.get<ArrayResponse<SubscriptionsList>>(`/company/${uuid}/Subscriptions${serializeQueryString(filter)}`);
  }
  // tslint:disable-next-line:no-any
  getListByClient(uuid: any, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    return this.get<ArrayResponse<SubscriptionsList>>(`/Client/${uuid}/Subscriptions${serializeQueryString(filter)}`);
  }
  // tslint:disable-next-line:no-any
  getListByClientSimple(uuid: any, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    return this.get<ArrayResponse<SubscriptionsList>>(`/Client/${uuid}/Subscriptions/All${serializeQueryString(filter)}`);
  }
  createAnomalyTask(): Observable<SendBackResult<boolean>> {
    return this.post<boolean>(`/billings/createanomalytask`, {});
  }
  // tslint:disable-next-line:no-any
  sendEmailAnomaly(data: any): Observable<SendBackResult<boolean>> {
    return this.post<boolean>(`/anomaly/NotifyAnomaliesFinance`, data);
  }
  // tslint:disable-next-line:no-any
  getAnomaliesList(filter: any): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    if (filter.anomalyType) {
      if (filter.anomalyType === 'ClientsMissingProject') {
        if ( filter.$orderBy === 'subscriptionName') {
          filter.$orderBy = 'name';
        }
        filter.missingproject = true;
        filter.name = filter.quickSearch;
        filter.quickSearch = null;
        return this.get<ArrayResponse<SubscriptionsList>>(`/clients/projects${serializeQueryString(filter)}`);
      } else {
        return this.get<ArrayResponse<SubscriptionsList>>(`/billings${serializeQueryString(filter)}`);
      }
    } else {
     return  of()
    }
  }
  // tslint:disable-next-line:no-any
  getSubscriptionListBySite(filter: any, uuid: any, clientUuid: any): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    // console.log(uuid, clientUuid)
    // console.log(filter)
    if ( filter.$orderBy === 'subscriptionName') {
      filter.$orderBy = 'name';
    }
    return this.get<ArrayResponse<SubscriptionsList>>(`/Clients/${clientUuid}/sites/${uuid}/Subscriptions${serializeQueryString(filter)}`);
  }


  getListByContract(uuid: string, filter: ContractFilter): Observable<SendBackResult<ArrayResponse<SubscriptionsList>>> {
    return this.get<ArrayResponse<SubscriptionsList>>(`/Contract/${uuid}/Subscriptions${serializeQueryString(filter)}`);
  }
  // tslint:disable-next-line:no-any
  isSFInvoiced(uuid: string): any {
    return this.put(`/client/${uuid}/ClientConfiguration/SalesforceInvoiced`, {} );
  }

}
